export default {
  LOAD_MY_STUDIES_CYCLE_LIST_START: 'LoadMyStudiesCycleListStart',
  LOAD_MY_STUDIES_CYCLE_LIST_END: 'LoadMyStudiesCycleListEnd',
  SORT_MY_STUDIES_CYCLE_LIST: 'SortMyStudiesCycleList'
};